import {Replacement} from '../interface';
import _ from 'lodash';
const localesReplacement = (replacements: Replacement, origin: string) => {
  const r = _.get(replacements, origin);
  return r ? r : origin;
};

export default localesReplacement;
